import { getTeamDetail } from '../api/Team';
import { getMyTeam } from '../api/User';

export const isTeamCteator = async (user_id) => {
  try {
    const { code, data } = await getMyTeam();
    if (code === '10000') {
      if (data.master.id === user_id) {
        return true;
      }
    }
  } catch (error) {
    // console.log(error);
  }
  return false;
};
